import { Media as MediaProps } from '.generated/Feature.CW.model';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import { withStandardComponentWrapper } from 'helpers/HOC';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import useIsEditing from 'lib/hooks/useIsEditing';
import React from 'react';
import { WistiaPlayer } from '@wistia/wistia-player-react';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';

export type MediaComponetProps = MediaProps.Media_Component;

const Media = (props: MediaComponetProps) => {
  const isEditing = useIsEditing();

  if (isEditing) {
    return (
      <div className="component">
        <div className="mx-auto px-10 lg:px-20 max-w-screen-xxl w-full overflow-hidden">
          <EditingHelpText>
            The Video Media Componet will not be shown in page builder. Only use External links for
            Video.
          </EditingHelpText>
          <div className="flex flex-wrap items-center gap-5 p-4">
            <span className="text-18 font-bold">Wistia Video Embed URL :- </span>
            <PlainTextWrapper field={props.fields?.videoID} />
          </div>
          <ImageWrapper
            field={props?.fields?.image}
            className="w-full h-full object-cover object-center rounded-lg aspect-[3/2]"
          />
        </div>
      </div>
    );
  }

  if (
    !isEditing &&
    props?.fields?.image?.value?.src !== undefined &&
    props?.fields?.image?.value?.src !== ''
  ) {
    return (
      <div className="component">
        <div className="mx-auto px-10 lg:px-20 max-w-screen-xxl w-full aspect-[3/2]">
          <ImageWrapper
            field={props?.fields?.image}
            className="w-full h-full object-cover object-center aspect-[3/2] rounded-md md:rounded-lg overflow-hidden"
          />
        </div>
      </div>
    );
  } else if (props.fields?.videoID?.value !== undefined && props.fields?.videoID?.value !== '') {
    return (
      <div className="component">
        {/* Video Player Section */}
        <div
          role="region"
          className="relative px-10 lg:px-20 max-w-screen-xxl w-full mx-auto aspect-video"
          aria-labelledby="Wistia video player container"
        >
          <div className="rounded-md md:rounded-lg overflow-hidden">
            <WistiaPlayer
              mediaId={props.fields?.videoID?.value}
              controlsVisibleOnLoad={false}
              endVideoBehavior="reset"
            />
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export const Default = withStandardComponentWrapper(Media);
